export default __webpack_public_path__ + "static/media/integracion.89a0305d.svg";